<template>
  <div class="search-member-container">
    <van-search
      v-model="search"
      show-action
      placeholder="搜索姓名、昵称、手机号"
      @input="oninput"
      @cancel="onCancel"
    />
    <div class="list-main">
      <van-empty v-if="isSearch" image="search" description="请输入关键字" />
      <template v-else>
        <template v-if="dataList.length">
          <div class="vipLise">
            <menberListCard
              v-for="(item, index) in dataList"
              :key="index"
              :item="item"
            />
          </div>
        </template>
        <van-empty v-else description="暂无数据" />
      </template>
    </div>
  </div>
</template>

<script>
import { apiPost } from "../../api/common";
import menberListCard from "./menberCard";

export default {
  data() {
    return {
      search: "",
      dataList: [], //搜索返回的结果
      shopInfo: {}, //当前登录的用户信息
    };
  },
  created() {
    this.shopInfo = Object.freeze(this.$route.query);
  },
  computed: {
    isSearch() {
      return this.search === "";
    },
  },
  components: {
    menberListCard,
  },
  methods: {
    //节流函数
    oninput: (function (duration) {
      let time = null;
      return function () {
        clearTimeout(time);
        const _this = this;
        time = setTimeout(() => {
          //发送请求函数
          // const userinfo = JSON.parse(sessionStorage.getItem("shopInfo"));
          if (!_this.search) return;
          const data = {
            shopId: this.shopInfo.id,
            keyword: _this.search,
          };
          if(!this.shopInfo.isSubAccount){
            data.shopCode = this.shopInfo.shopCode
          }else{
            data.account = this.shopInfo.id
          }
          apiPost("/mem//member/query", data).then((res) => {
            if (res.data.code === "0000") {
              _this.dataList = Object.freeze(
                res.data.data.results.mbrInfoQueryVoList
              );
            }
          });
        }, duration);
        return;
      };
    })(500),
    onCancel() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="less" scoped>
.list-main {
  // margin-top: 15px;
}
.vipLise {
  background-color: #fff;
  padding: 3px 15px;
  .vipLise-item:not(:last-child)::after {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: rgba(187, 187, 187, 100);
    bottom: 0;
    transform: scaleY(0.5);
  }
}
</style>